import React from "react";
import { Helmet } from "react-helmet";
import { RouteProps } from "react-router-dom";
import { CorePostTypesAcf } from "../../constants/types/acf";
import { useCurrentRouteData, } from "../../services/app-state";
import { useSuburbName } from "../../utils";
import { shouldShowLocalServices } from "../../utils/post-type-page-utils";
import { Separator } from "../atoms/Separator";
import { RelatedLocalCta } from "../molecules/RegionSelectCta";
import { ErrorBoundary } from "../organisms/ErrorBoundary";
import { HeroPostTypePage } from "../organisms/HeroPostTypePage";
import { PageFeedback } from "../organisms/PageFeedback";
import { PageWrapper } from "../organisms/PageWrapper";
import { PostTypePageContent } from "../organisms/PostTypePageContent";
import { RelatedLocalServices } from "../organisms/RelatedLocalServices";
const PostTypePageTemplateInner: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData<CorePostTypesAcf>();
    const preferredTitle = page.acf.meta?.sentence_case_title ?? page.title.rendered;
    const suburbName = useSuburbName();

    return (
        <>
            <Helmet>
                <title>Support for {preferredTitle}</title>
            </Helmet>
            <HeroPostTypePage
                image={page.acf.meta?.hero_image}
                title={
                    <>
                         <strong>Support for <span>{preferredTitle}</span></strong>
                    </>
                }
            />
            <PageWrapper>
                <PostTypePageContent
                    page={page}
                    showLocalServicesAnchor={shouldShowLocalServices(page)}
                />
                {suburbName && shouldShowLocalServices(page) ? 
                    <>
                        <br id="services"/>
                        <RelatedLocalServices post={page} />
                        <Separator />
                    </>
                : <></>}
                {!suburbName && shouldShowLocalServices(page) ?
                    <>
                        <br id="services" />
                        <RelatedLocalCta />
                    </>
                : <></>}      
                <PageFeedback reviewedDate={page.modified} />
            </PageWrapper>
        </>
    );
};

export const PostTypePageTemplate: React.FC<RouteProps> = props => (
    <ErrorBoundary>
        <PostTypePageTemplateInner {...props} />
    </ErrorBoundary>
);

export default PostTypePageTemplate;
